import { Patient } from '@/types/patient';
import { StateCreator } from 'zustand';

interface PatientStoreHandlers {
  setPatient: (patient: Patient | null) => void;
  updatePatient: (updates: Partial<Patient>) => void;
  clearPatient: () => void;
  setPatientLoading: (loading: boolean) => void;
}

interface PatientFields {
  patient: Patient | null;
  isPatientLoading: boolean;
}

export interface PatientState extends PatientStoreHandlers, PatientFields {}

export const createPatientSlice: StateCreator<PatientState, [], [], PatientState> = set => ({
  patient: null,
  isPatientLoading: false,

  setPatient: (patient: Patient | null): void => set({ patient }),

  updatePatient: (updates: Partial<Patient>): void =>
    set(state => ({
      patient: state.patient ? { ...state.patient, ...updates } : null,
    })),

  clearPatient: (): void => set({ patient: null }),

  setPatientLoading: (loading: boolean): void => set({ isPatientLoading: loading }),
});
